import { useEffect } from "react";
import { useContent } from "../content/ContentContext";
import { setPageMeta } from "../lib/seo";
import { SectionLabel } from "../components/Ui";
import { Reveal } from "../components/Reveal";
import CaseCard from "../components/CaseCard";

export default function Work() {
  const { content } = useContent();
  const { caseStudies } = content;
  const visible = caseStudies.filter((c) => !c.hidden);
  useEffect(() => {
    setPageMeta(
      "Selected Work — Savvy Stephanie Analytics & Consulting",
      "Five case studies from professional experience: invoice reconciliation, returns analysis, reporting automation, supply chain visibility and process improvement."
    );
  }, []);
  return (
    <main className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8 lg:py-20">
      <Reveal>
        <SectionLabel>Selected Work</SectionLabel>
        <h1 className="mt-5 max-w-3xl font-serif text-4xl font-semibold tracking-tight text-ink sm:text-5xl">
          Examples of how I work, honestly labelled.
        </h1>
        <p className="mt-6 max-w-2xl text-lg leading-relaxed text-muted">
          Professional experience, anonymised, with results stated only where I have
          supplied evidence. The interactive dashboards behind each project are
          illustrative reconstructions using synthetic data.
        </p>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-2 lg:gap-8">
        {visible.map((cs, i) => (
          <Reveal key={cs.id} delay={(i % 2) * 0.08} className="h-full">
            <CaseCard cs={cs} large />
          </Reveal>
        ))}
      </div>
    </main>
  );
}
